import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { NavService } from './base/services/nav/nav.service';
import { Title } from '@angular/platform-browser';
import { AppidService } from './base/services/appid/appid.service';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
    public innerWidth: any;

    constructor(private nav: NavService, private appid: AppidService, private appTitle: Title) { }

    ngOnInit(): void {
        this.innerWidth = window.innerWidth;
        let result = this.nav.loadNavsByCache();

        if(this.appid.appName) {
            this.appTitle.setTitle(this.appid.appName);
        }

        this.appid.appID$
            .subscribe(appID => {

                // In GM we make the background completely black because that way the "flash" looks better when navigating between pages. In other apps we keep the white background.
                if (appID === 434693) {
                    document.body.classList.add('black-theme');
                }
            });
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.innerWidth = window.innerWidth;
    }

    ngOnDestroy(): void {

    }
}
